import { Link as RouterLink } from 'react-router-dom';
import WithScroll from 'hocs/WithScroll';

const FooterLink = ({
  scroll: { triggerScrolling },
  preventScroll,
  ...props
}) => {
  const handleClick = e => {
    if (!e.ctrlKey && !e.metaKey && !preventScroll) {
      triggerScrolling();
    }
  };

  return (
    <RouterLink className="footer__nav-link" onClick={handleClick} {...props} />
  );
};

export default WithScroll(FooterLink);
